import { Injectable } from '@angular/core';
import { FieldType } from '@sla-ng/ui-material';
import { IPlannedPurchasePriceDialogLayout } from '../../models/layout/planned-purchase-price-dialog-layout.model';
import { IPlannedPurchasePriceLayout } from '../../models/layout/planned-purchase-price-layout.model';
import { SharedDataFacade } from '../facades/master-data/shared-data.facade';

@Injectable({
    providedIn: 'root',
})
export class PlannedPurchasePriceLayoutService {

    constructor(protected mySharedDataFacade: SharedDataFacade) {
    }

    public getPlannedPurchasePriceLayout(): IPlannedPurchasePriceLayout {
        return {
            columns: [ 'articleNr', 'article', 'validFrom', 'validTo', 'measureUnit' ,'priceCt', 'actions' ],
            filterFields: [
                {
                    type: FieldType.select,
                    label: 'app.model.planned-purchase-price.article.label',
                    field: 'articleId',
                    withClearButton: true,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'articleNr', 'name' ],
                        separator: ' - ',
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchArticles(),
                    },
                },
                { field: 'dateFilter', type: FieldType.daterange, label: 'app.page.planned-purchase-price.date-filter.label', withClearButton: true },
            ],
        };
    }

    public getUpdateDialogLayout(): IPlannedPurchasePriceDialogLayout {
        return {
            fields: [
                {
                    type: FieldType.select,
                    label: 'app.model.planned-purchase-price.article.label',
                    field: 'articleId',
                    required: true,
                    disabled: true,
                    readonly: true,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'articleNr', 'name' ],
                        separator: ' - ',
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchArticles(),
                    },
                },
                {
                    type: FieldType.select,
                    label: 'app.model.planned-purchase-price.measure-unit.label',
                    field: 'measureUnitId',
                    disabled: true,
                    readonly: true,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchMeasureUnits(),
                    },
                },
                {
                    type: FieldType.decimal,
                    label: 'app.model.planned-purchase-price.priceCt.label',
                    field: 'priceEuro',
                    required: true,
                },
                {
                    type: FieldType.daterange,
                    label: 'app.model.planned-purchase-price.daterange.label',
                    field: 'dateRange',
                    required: true,
                },
            ],
        };
    }

    public getAddDialogLayout(): IPlannedPurchasePriceDialogLayout {
        return {
            fields: [
                {
                    type: FieldType.select,
                    label: 'app.model.planned-purchase-price.article.label',
                    field: 'articleId',
                    required: true,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'articleNr', 'name' ],
                        separator: ' - ',
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchArticles(),
                    },
                },
                {
                    type: FieldType.select,
                    label: 'app.model.planned-purchase-price.measure-unit.label',
                    field: 'measureUnitId',
                    disabled: true,
                    readonly: true,
                    required: false,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchMeasureUnits(),
                    },
                },
                {
                    type: FieldType.decimal,
                    label: 'app.model.planned-purchase-price.priceCt.label',
                    field: 'priceEuro',
                    required: true,
                },
                {
                    type: FieldType.daterange,
                    label: 'app.model.planned-purchase-price.daterange.label',
                    field: 'dateRange',
                    required: true,
                },
            ],
        };
    }


}
